import React from 'react';
import { MenuItem, Select, SelectProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledSelect = styled(Select)<SelectProps>(({ theme }) => ({
  height: 36,
  minWidth: 159,
  borderRadius: 6,
  fontWeight: 500,
  fontSize: 16,
  lineHeight: '22px',
  letterSpacing: '0.01em',
  backgroundColor: '#FFF',
  '& .MuiSelect-select': {
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
  },
}));

export interface HLDropdownProps extends SelectProps {
  options: Array<{ label: string; value: string | number }>;
}

function HLDropdown({ options, value, onChange, ...props }: HLDropdownProps) {
  return (
    <StyledSelect value={value} onChange={onChange} {...props}>
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </StyledSelect>
  );
}

export default HLDropdown;
